import {
  Container,
  Group,
  NavLink,
  Paper,
  Stack,
  Card,
} from '@mantine/core';
import BusinessIcon from '@mui/icons-material/Business';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Groups3Icon from '@mui/icons-material/Groups3';
import KeyIcon from '@mui/icons-material/Key';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PaymentIcon from '@mui/icons-material/Payment';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import {
  createFileRoute,
  Link,
  Outlet,
} from '@tanstack/react-router';
import React, {
  useEffect,
  useState,
} from 'react';
import {
  useAuth,
} from 'react-oidc-context';

import styles from '#features/auth/Settings.module.scss';
import {
  type AuthDecoded,
} from '#src/types/auth';

// import BusinessIcon from '@mui/icons-material/Business';

export const Route = createFileRoute('/_app/_authenticated/settings')({
  beforeLoad: () => {
    return {
      crumb: 'Settings',
    };
  },
  component: RouteComponent,
});

function RouteComponent(): React.ReactNode {
  const auth = useAuth();
  const [
    user,
    setUser,
  ] = useState<AuthDecoded>();
  useEffect(() => {
    if (auth.user) {
      setUser(auth.user as unknown as AuthDecoded);
    }
  }, [auth.user]);
  return (
    <>
      <Paper
        className={ styles.settingsContainer }
        shadow="xl"
        radius="md"
        p="xl"
        m="lg"
      >
        <Group
          w="100%"
          wrap="nowrap"
          preventGrowOverflow={ false }
          grow
        >
          <Stack
            className={ styles.sectionsCol }
            justify="flex-start"
            align="stretch"
            gap="xs"
            h="100%"
          >
            { user?.profile?.groups.includes('client-admin') && (
              <>
                <NavLink
                  className={ styles.navLinks }
                  component={ Link }
                  to="/settings/users"
                  variant="filled"
                  label="Users"
                  description="Manage user access and engagement settings"
                  leftSection={ <Groups3Icon /> }
                  rightSection={ <ChevronRightIcon /> }
                />
                <NavLink
                  className={ styles.navLinks }
                  component={ Link }
                  to="/settings/clients"
                  variant="filled"
                  label="Clients"
                  description="Manage subscription clients"
                  leftSection={ <SupervisedUserCircleIcon /> }
                  rightSection={ <ChevronRightIcon /> }
                />
              </>
            ) }
            <NavLink
              className={ styles.navLinks }
              component={ Link }
              to="/settings/company"
              variant="filled"
              label="Company"
              description="Adjust company details and operational preferences"
              leftSection={ <BusinessIcon /> }
              rightSection={ <ChevronRightIcon /> }
            />
            <NavLink
              className={ styles.navLinks }
              component={ Link }
              to="/settings/profile"
              variant="filled"
              label="Profile"
              description="Update personal information and interaction preferences"
              leftSection={ <ManageAccountsIcon /> }
              rightSection={ <ChevronRightIcon /> }
            />
            <NavLink
              className={ styles.navLinks }
              component={ Link }
              to="/settings/subscription"
              variant="filled"
              label="Subscription"
              description="Manage your subscriptions and payments"
              leftSection={ <KeyIcon /> }
              rightSection={ <ChevronRightIcon /> }
            />
            <NavLink
              className={ styles.navLinks }
              component={ Link }
              to="/settings/payment"
              variant="filled"
              label="Payments"
              description="Manage your payment details"
              leftSection={ <PaymentIcon /> }
              rightSection={ <ChevronRightIcon /> }
            />
          </Stack>

          <Container
            className={ styles.outletCol }
            mx={ 0 }
            miw="80%"
            h="100%"
          >
            <Card
              bg="transparent-dark.7"
              shadow="xl"
              padding="lg"
              radius="lg"
              withBorder
            >
              <Outlet />
            </Card>
          </Container>
        </Group>
      </Paper>
    </>
  );
}
